<script>
    import clientJournalActions from './client-journal-actions.vue';
    import clientJournalTable from './client-journal-table.vue';
    import clientJournalCounter from './client-journal-counter.vue';
    import toaster from "../common/toaster";

    export default {
        components: {
            clientJournalActions,
            clientJournalTable,
            clientJournalCounter
        },
        data() {
            return {
                t_filter_load_error: Lang.langGet("Failed to load filter."),
                existing_filters: [],
                selected_filter: -1,
            }
        },
        methods: {
            loadFilter: function () {
                axios.post('/system/client-journal/filter', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.existing_filters = response.data.data;
                    this.selected_filter = response.data.selected_filter;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_filter_load_error);
                });
            }
        },
        mounted() {
            this.loadFilter();

            EaseEventBus.listen('updateExistingFilters', () => {
                this.loadFilter();
            });
        }
    }
</script>
